export default {"src":"/_next/static/media/plusIcon.9622f153.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};